import React from 'react'
import './animation.css'
import { FiGithub } from "react-icons/fi";
import { AiOutlineInstagram } from "react-icons/ai";
import { FaLink, FaLinkedin } from "react-icons/fa";
const ContactUs = () => {
  return (
<div className="bg-background flex justify-center items-center pb-10 pt-10">
      <div className="md:w-2/5 mx-5 fade-in">
        <div className="pb-4 text-center">
          <div className="text-header text-2xl font-sans-bold">
            INTERESTED IN COLLABORATING?
          </div>
          <a href="mailto:caletina.marklester@gmail.com">
          <div className='pt-5'>
          <button className="text-white border text-xs py-3 px-10 rounded font-sans hover:bg-header hover:text-black hover:-translate-y-1 transition duration-500 ease-in-out">
              Send me a message!
            </button>   
            </div>   
            </a>  

            </div>

      <div className='flex justify-center'>
      <a
                href="https://github.com/rainisthename"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className='pr-2'>
                <FiGithub className="text-gray-400 text-2xl mb-5 hover:-translate-y-1 transition duration-500 ease-in-out hover:text-header hover:cursor-pointer" />
                </div>
              </a>
              <a
                href="https://www.instagram.com/lstrbumbilya/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiOutlineInstagram className="text-gray-400 text-2xl mb-5 hover:-translate-y-1 transition duration-500 ease-in-out hover:text-header hover:cursor-pointer" />

              </a>
              <a
                href="https://www.linkedin.com/in/marklstrcaletina"
                target="_blank"
                rel="noopener noreferrer"
              >
                 <div className='pl-2'>
                <FaLinkedin className="text-gray-400 text-2xl mb-5 hover:-translate-y-1 transition duration-500 ease-in-out hover:text-header hover:cursor-pointer" />
              </div>
              </a>

      </div>
      </div>
    </div>  )
}

export default ContactUs